"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvalidExpressionChildError = function (_Error) {
  _inherits(InvalidExpressionChildError, _Error);

  function InvalidExpressionChildError() {
    var _ref;

    _classCallCheck(this, InvalidExpressionChildError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = InvalidExpressionChildError.__proto__ || Object.getPrototypeOf(InvalidExpressionChildError)).call.apply(_ref, [this].concat(args)));

    Error.captureStackTrace(_this, InvalidExpressionChildError);
    return _this;
  }

  return InvalidExpressionChildError;
}(Error);

exports.default = InvalidExpressionChildError;